import {ComponentProps, FC} from 'react';
import {Controller, useFormContext, Validate} from 'react-hook-form';

import {FileUploadField} from './base';

type FileUploaderProps = {
    validate?: Validate<File, Record<string, unknown>>;
} & Omit<
    ComponentProps<typeof FileUploadField>,
    'onChange' | 'onReset' | 'value'
>;

const FileUpload: FC<FileUploaderProps> = ({name, validate, ...props}) => {
    const {control} = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={(renderProps) => (
                <FileUploadField
                    error={renderProps.fieldState.error}
                    name={name}
                    onChange={(value) => {
                        if (!value) return renderProps.field.onChange(null);
                        const file = value[0];
                        if (!file) return renderProps.field.onChange(null);
                        renderProps.field.onChange(file);
                    }}
                    onReset={() => {
                        renderProps.field.onChange(null);
                    }}
                    value={renderProps.field.value}
                    {...props}
                />
            )}
            rules={{
                required: props.required,
                validate,
            }}
        />
    );
};

export default FileUpload;
